import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var postalCashHistory = [{
  path: "postal-cash-history",
  name: "postal-cash-history",
  component: function component() {
    return import("./postal-cash-history.vue");
  }
}];